module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-01"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_IX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_IX"
    }
  }, [_vm._v("KEY TO PANELS")])])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_IX"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This key to the panels helps locate the special and suggested exercises that occur throughout the volume. It should be noted that the panels are not exhaustive treatments of topics, and are meant to be read and used in their contexts.")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("‘THINK ABOUT’ PANELS")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-003"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "5",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthropopathisms")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-006",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YHWH’s actions in Joshua 1—12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-008",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responses to the "), _c('i', [_vm._v("kherem")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-017",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knowing "), _c('span', {
    staticClass: "small"
  }, [_vm._v("YHWH")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Form criticism and Judges 2 and 6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-025",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The angel of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("YHWH")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-026",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gideon: is he so bad?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-027",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jephthah’s vow")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-028",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magic hair?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-030",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Narrative technique and the message of Judges 19")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-031",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("kherem ")]), _vm._v("in 1 Samuel 15")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-036",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saul’s séance")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-039",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abner’s death")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-040",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The account of Michal")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-041",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ziba and Mephibosheth")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-043",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeroboam: was he so bad?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-051",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Which king and which prophet?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-056",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Women’s roles in the book of Ruth")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-073",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ruth")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Esther and Mordecai: compromisers or loyal Jews?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-075",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greek Esther")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-077",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Esther 9 and 10: later additions?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-078",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comedy in the Bible")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-079",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two perspectives on Esther")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-080",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixed marriages")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-085",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intentional unevenness?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-088",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon’s succession: two contradictory accounts?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-096",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("‘DIGGING DEEPER’ PANELS")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-004"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joshua 3—4: a jumbled narrative?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-005",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘devoted things’ and Achan’s sin")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-007",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ancient Near Eastern context anddating Joshua")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-012",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Merneptah Stele")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-014",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A fifteenth-century or a thirteenth-century conquest?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-016",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jericho and Bethel")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-019",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two introductions to Judges?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-022",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judges 4 and 5: two accounts?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-024",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judges 20:29–48: a single narrative?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-032",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 1—15 and Judges")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-034",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The evil spirit from "), _c('span', {
    staticClass: "small"
  }, [_vm._v("YHWH")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-037",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 16—17: A double narrative?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-038",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David and the temple")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-042",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two views of 2 Samuel 21:1–14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-045",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon’s glory: fact or fiction?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-049",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The boys and the bears")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-058",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Form criticism and the Elisha narratives")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-059",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_X"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_X"
    }
  }), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unexpected endings")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-061",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sennacherib and Jerusalem")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-063",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editorial layers in 1 Kings 11:29–38")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-070",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua–Kings and theories of historiography")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purim")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-076",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who were ‘the people of the land’?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-083",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding chronology in Ezra 4—6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-084",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Similarities with Chronicles?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-087",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Did Ezra and Nehemiah know each other?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-089",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Did the Chronicler write Ezra—Nehemiah?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-090",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘man of peace’")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-095",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chronicler on the kings of Judah")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-097",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Immediate retribution’?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-098",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The sons of Zerubbabel")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-099",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("OTHER PANELS")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-005"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-001"
    }
  }, [_vm._v("The text of the Histories")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-001"
    }
  }, [_c('b', [_vm._v("What are the histories?")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-02"
    }
  }, [_vm._v("The place of the Histories in three Old Testament canons")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-02"
    }
  }, [_c('b', [_vm._v("What are the histories?")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The periods of ancient Near Eastern history")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-002",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The ancient Near East, 1550 –63 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology of the ancient Near East")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-003",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The ancient Near East, 1550 –63 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Joshua")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-004",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The nations of Canaan")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joshua 1—12 and ancient Near Eastern conquest accounts")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-010",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The land that remains’")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-011",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Amarna letters")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-013",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The capture of Jericho and Ai: historical events?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-015",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Judges")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echoes of Joshua 23—24")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-020",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judges 2:11–19 and 3:7–11 compared")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-023",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judges 3:7–11 represented as separate ‘elements’")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v("’s spirit in Judges 13—16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-029",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Judges")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of 1 and 2 Samuel")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-033",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel’s victory: a fiction?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-035",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of 2 Samuel 21—24")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-044",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology of Saul’s, David’s and Solomon’s reigns")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-046",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inscriptional references to David?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-047",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Samuel")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Kings")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-048",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early kings of Israel and Judah (1 Kgs 12—16)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-050",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moabite Stone")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-052",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regnal formulae in Kings")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-053",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kings in the period of Elijah and Elisha (1 Kgs 17—2 Kgs 10)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-054",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The battle against Baal and Ahab’s line")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-055",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aram in 1 and 2 Kings")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-057",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Later kings of Israel and Judah (2 Kgs 11–17)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-060",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The last kings of Judah")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-062",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who could consult the three ‘Books’?")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-064",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The make-up of Kings")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-065",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Kings")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Definitions: ‘Deuteronomic’ and ‘Deuteronomistic’")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-066",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua–Kings and theories of historiography")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Noth’s case in outline")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-067",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua–Kings and theories of historiography")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘Cross school’")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-068",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua–Kings and theories of historiography")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘Smend school’")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-069",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joshua–Kings and theories of historiography")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Ruth")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-071",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ruth")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Widows in ancient Israel")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-072",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ruth")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Esther")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-074",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Esther")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persian kings, 550–358 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-081",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Ezra and Nehemiah")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-082",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enslavement in Israel")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-086",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezra and Nehemiah")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Chronicles")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-091",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The nature of genealogies")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-092",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Variations in tribal lists")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-093",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order of the tribes in Genesis and 1 Chronicles")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-094",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 and 2 Chronicles")])])])])])])])])])])])])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_IX"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_IX"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 72
// module chunks = 0